"use client";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Button from "../ui/Button";
import useAuthInfo from "@/store/auth";
import Profile from "../partials/header/Tools/Profile";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

export default function MobileDrawer({ isOpen, onClose }) {
  const userData = useAuthInfo((state) => state);
  const path = usePathname();
  const [isHidden, setIsHidden] = useState(true);

  //Check if route changes then close drawer
  useEffect(() => {
    if (isOpen) {
      onClose();
    }
  }, [path]);

  useEffect(() => {
    setTimeout(() => {
      setIsHidden(false);
    }, 200);
  }, []);

  return (
    <div
      className={`fixed flex flex-col justify-center items-center z-10 top-0 right-0 h-full w-full bg-white text-black transition-transform duration-300 transform ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } ${isHidden ? "hidden" : ""}`}
    >
      <button className="absolute right-7 top-4 p-3" onClick={onClose}>
        <FontAwesomeIcon className="text-5xl" icon={faXmark} />
      </button>
      <ul className="flex flex-col justify-center items-center space-y-4">
        {userData.apiToken && <Profile />}
        <Link onClick={onClose} href="/download">
          <li className="border-b md:border-b-0">Download</li>
        </Link>
        <Link onClick={onClose} href="/campaigns">
          <li className="border-b md:border-b-0 md:border-r-2">Campaigns</li>
        </Link>
        <Link onClick={onClose} href="/discover">
          <li className="border-b md:border-b-0 md:border-r-2">Discover</li>
        </Link>
        <Link onClick={onClose} href="/">
          <li className="border-b md:border-b-0 md:border-r-2">Home</li>
        </Link>

        {/* <Link onClick={onClose} href="/supply">
          <li className="border-b md:border-b-0 md:border-r-2 ">Supply</li>
        </Link> */}

        {/* <Link onClick={onClose} href="/referral">
          <li className="border-b md:border-b-0 md:border-r-2 ">Earn</li>
        </Link> */}
        {/* <Link onClick={onClose} href="/stokvels">
          <li className="border-b md:border-b-0 md:border-r-2 ">Stokvel</li>
        </Link> */}
        <Link onClick={onClose} href="/blog">
          <li className="border-b md:border-b-0 md:border-r-2 ">Blogs</li>
        </Link>
        {userData.apiToken && (
          <>
            <Link onClick={onClose} href="/portfolio">
              <li className="border-b md:border-b-0">Portfolio</li>
            </Link>
          </>
        )}

        {!userData.apiToken && (
          <>
            <Link onClick={onClose} href="/login">
              <Button className="bg-transparent">Login</Button>
            </Link>
            <Link onClick={onClose} href="/register">
              <Button className="bg-transparent border-stone-600 border-2 rounded-full py-3">
                Sign Up
              </Button>
            </Link>
          </>
        )}

        {/* Add other navigation links */}
      </ul>
    </div>
  );
}
